module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "campaign-brief"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Reload Campaigns"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.fields,
      "items": _vm.campaigns,
      "items-per-page": _vm.itemsPerPage,
      "data-app": ""
    },
    scopedSlots: _vm._u([{
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "layout px-0"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "modal",
            "data-target": "#view_campaign_modal",
            "disabled": (item.activated === _vm.campaignActivationStatusConfig.ACTIVATED) ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), (item.status === _vm.campaignStatusConfig.PENDING_CLIENT_APPROVAL) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Campaign",
            "color": "success",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.approveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.startEliminate(item.id, item.status)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-users-cog",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        })])], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data Received")]
      },
      proxy: true
    }], null, true)
  })], 1)])]), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "value": _vm.viewModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewModalDialog),
      callback: function($$v) {
        _vm.viewModalDialog = $$v
      },
      expression: "viewModalDialog"
    }
  }), _vm._v(" "), _c('influencer-elimination', {
    attrs: {
      "campaingData": _vm.campaingData
    },
    model: {
      value: (_vm.eliminationDialog),
      callback: function($$v) {
        _vm.eliminationDialog = $$v
      },
      expression: "eliminationDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1250"
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Paired influencers")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm.measurement.invitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm.measurement.notInvitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Handle")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Followers")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Eng. Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Aud. Cred")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Elimination Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pairedInfluencers), function(item) {
          return _c('tr', {
            key: item.instagramHandle
          }, [_c('td', [(item.influencer_details.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.instagramHandle))]) : (item.influencer_details.platform === 'youtube') ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.followers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.engagement_rate) + "%")]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                " + _vm._s(item.audience_credibility) + "\n              ")], 1), _vm._v(" "), _c('td', [_c('v-chip', _vm._g({
            staticClass: "ma-2",
            attrs: {
              "color": _vm.eliminatinStatusColor(item.eliminationStatus),
              "x-small": "",
              "text-color": "white"
            }
          }, _vm.on), [_vm._v("\n                  " + _vm._s(_vm.eliminationStatusDisplay(item.eliminationStatus)) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-check")])], 1)], 1)])
        }), 0)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.viewInfluencerDialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ceec46e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignBrief.vue
// module id = 2022
// module chunks = 0